import { EditFilled } from "@livechat/design-system-icons";

import { ITarget } from "store/entities/application-settings/interfaces";

import { IFilterConfig, IFilterLabelValue } from "../interfaces";

export const targetFilterConfig: IFilterConfig = {
  title: "Change area",
  icon: EditFilled,
  multiple: false,
  getFilterLabelValues: (filterValues: string, targets: Record<string, ITarget>): IFilterLabelValue[] => {
    if (filterValues === null) {
      return [];
    }
    return [
      {
        key: filterValues,
        label: targets[filterValues]?.labelPlural || "Unknown",
      },
    ];
  },
};
